import styled from '@emotion/styled';
import { createElement, FC } from 'react';

type Props = {
  className?: string;
};

const FacebookDevice11: FC<Props> = (props) => (
  <Root viewBox="0 0 145.78 300.88" {...props}>
    <defs>
      <style>
        {
          '.facebook1-1_svg__cls-1{fill:#fff}.facebook1-1_svg__cls-4{fill:#424242}.facebook1-1_svg__cls-5{fill:#eee}.facebook1-1_svg__cls-6{fill:#9e9e9e}'
        }
      </style>
    </defs>
    <g id="facebook1-1_svg__\u30EC\u30A4\u30E4\u30FC_2" data-name="\u30EC\u30A4\u30E4\u30FC 2">
      <g id="facebook1-1_svg__\u30EC\u30A4\u30E4\u30FC_1-2" data-name="\u30EC\u30A4\u30E4\u30FC 1">
        <rect width={145.78} height={300.88} rx={21.72} />
        <path className="facebook1-1_svg__cls-1" d="M6.28 39.65h131.78v21.96H6.28z" />
        <path
          d="M138.27 39.65v-18A14.31 14.31 0 00124 7.33h-14.16v1.92a7.59 7.59 0 01-7.59 7.59H43.14a7.59 7.59 0 01-7.59-7.59V7.33h-15A14.31 14.31 0 006.28 21.64v18z"
          fill="#1978f2"
        />
        <rect x={28.77} y={23.42} width={89.01} height={11.38} rx={5.69} fill="#0d56b3" />
        <circle className="facebook1-1_svg__cls-4" cx={18.79} cy={49.79} r={6.62} />
        <path className="facebook1-1_svg__cls-5" d="M29.15 44.96h34.37v3.94H29.15zM29.15 51.05h55.23v4.21H29.15z" />
        <path
          className="facebook1-1_svg__cls-1"
          d="M6.28 193.45v85.79a14.31 14.31 0 0014.31 14.31H124a14.31 14.31 0 0014.31-14.31v-85.79z"
        />
        <circle className="facebook1-1_svg__cls-4" cx={18.79} cy={229.7} r={6.62} />
        <path className="facebook1-1_svg__cls-5" d="M29.15 224.86h34.37v3.94H29.15zM29.15 230.95h55.23v4.21H29.15z" />
        <rect x={53.71} y={286.02} width={34.73} height={3.52} rx={1.76} />
        <path className="facebook1-1_svg__cls-4" d="M6.21 61.61h131.84v131.84H6.21z" />
        <path className="facebook1-1_svg__cls-5" d="M6.21 241.88h131.84v24.42H6.21z" />
        <circle className="facebook1-1_svg__cls-6" cx={21.48} cy={202.4} r={3.92} />
        <path className="facebook1-1_svg__cls-5" d="M29.13 200.27h15.28v3.94H29.13z" />
        <circle className="facebook1-1_svg__cls-6" cx={63.08} cy={202.4} r={3.92} />
        <path className="facebook1-1_svg__cls-5" d="M70.73 200.27h15.28v3.94H70.73z" />
        <circle className="facebook1-1_svg__cls-6" cx={101.06} cy={202.4} r={3.92} />
        <path className="facebook1-1_svg__cls-5" d="M108.71 200.27h15.28v3.94h-15.28zM6.2 213.42h132.05v4.21H6.2z" />
        <circle cx={22.33} cy={275.27} r={4.48} fill="#1878f2" />
        <circle className="facebook1-1_svg__cls-6" cx={55.6} cy={275.27} r={4.48} />
        <circle className="facebook1-1_svg__cls-6" cx={88.86} cy={275.27} r={4.48} />
        <circle className="facebook1-1_svg__cls-6" cx={122.12} cy={275.27} r={4.48} />
      </g>
    </g>
  </Root>
);

const Root = styled('svg')();

export default FacebookDevice11;
